// This file is AUTOGENERATED, do not edit it manually!!!

import { inlineEdit as inlineEditde } from './inlineEditResx.de';
import { inlineEdit as inlineEditen } from './inlineEditResx.en';
import { inlineEdit as inlineEditen_risk } from './inlineEditResx.en_risk';
import { inlineEdit as inlineEdites } from './inlineEditResx.es';
import { inlineEdit as inlineEditfr } from './inlineEditResx.fr';
import { inlineEdit as inlineEditit } from './inlineEditResx.it';
import { inlineEdit as inlineEditnl } from './inlineEditResx.nl';
import { inlineEdit as inlineEditpl } from './inlineEditResx.pl';
import { inlineEdit as inlineEditpt } from './inlineEditResx.pt';
import { inlineEdit as inlineEditru } from './inlineEditResx.ru';
import { inlineEdit as inlineEditsk } from './inlineEditResx.sk';
import { inlineEdit as inlineEditsv } from './inlineEditResx.sv';
import { inlineEdit as inlineEdittr } from './inlineEditResx.tr';

const langMap: { [k: string]: Partial<typeof inlineEditen> } = {
    de: inlineEditde,
    en: inlineEditen,
    en_risk: inlineEditen_risk,
    es: inlineEdites,
    fr: inlineEditfr,
    it: inlineEditit,
    nl: inlineEditnl,
    pl: inlineEditpl,
    pt: inlineEditpt,
    ru: inlineEditru,
    sk: inlineEditsk,
    sv: inlineEditsv,
    tr: inlineEdittr,
};

/* tslint:disable: max-line-length */
export const inlineEditResx = {
    /**
    * en: {0} has been successfully undone
    */
    get action_has_been_successfully_undone() {
        return langMap[ep.resxCulture].action_has_been_successfully_undone || langMap.en.action_has_been_successfully_undone;
    },
    /**
    * en: We're sorry, but we couldn't undo the action.
    */
    get action_has_not_been_successfully_undone() {
        return langMap[ep.resxCulture].action_has_not_been_successfully_undone || langMap.en.action_has_not_been_successfully_undone;
    },
    /**
    * en: The action will be undone: {0}
    */
    get action_will_be_undo_message() {
        return langMap[ep.resxCulture].action_will_be_undo_message || langMap.en.action_will_be_undo_message;
    },
    /**
    * en: Time logs for all subactivities:
    */
    get ActivityChildrenActualHours_Text() {
        return langMap[ep.resxCulture].ActivityChildrenActualHours_Text || langMap.en.ActivityChildrenActualHours_Text;
    },
    /**
    * en: Estimated hours for all subactivities:
    */
    get ActivityChildrenEstimatedHours_Text() {
        return langMap[ep.resxCulture].ActivityChildrenEstimatedHours_Text || langMap.en.ActivityChildrenEstimatedHours_Text;
    },
    /**
    * en: Budget for the activity:
    */
    get ActivityOwnBudget_Text() {
        return langMap[ep.resxCulture].ActivityOwnBudget_Text || langMap.en.ActivityOwnBudget_Text;
    },
    /**
    * en: Estimated hours for the activity:
    */
    get ActivityOwnEstimatedHours_Text() {
        return langMap[ep.resxCulture].ActivityOwnEstimatedHours_Text || langMap.en.ActivityOwnEstimatedHours_Text;
    },
    /**
    * en: Budget for all subactivities:
    */
    get ActivitySubactivitiesBudget_Text() {
        return langMap[ep.resxCulture].ActivitySubactivitiesBudget_Text || langMap.en.ActivitySubactivitiesBudget_Text;
    },
    /**
    * en: Actual completion
    */
    get ActualCompletion_Text() {
        return langMap[ep.resxCulture].ActualCompletion_Text || langMap.en.ActualCompletion_Text;
    },
    /**
    * en: Actual spent hours, total:
    */
    get ActualHours_Total_Text() {
        return langMap[ep.resxCulture].ActualHours_Total_Text || langMap.en.ActualHours_Total_Text;
    },
    /**
    * en: Add time entry
    */
    get AddTimeEntry_Text() {
        return langMap[ep.resxCulture].AddTimeEntry_Text || langMap.en.AddTimeEntry_Text;
    },
    /**
    * en: Invite User
    */
    get AddUser_Text() {
        return langMap[ep.resxCulture].AddUser_Text || langMap.en.AddUser_Text;
    },
    /**
    * en: Add weekly time
    */
    get AddWeeklyTime_Text() {
        return langMap[ep.resxCulture].AddWeeklyTime_Text || langMap.en.AddWeeklyTime_Text;
    },
    /**
    * en: Apply
    */
    get Apply() {
        return langMap[ep.resxCulture].Apply || langMap.en.Apply;
    },
    /**
    * en: Assignees
    */
    get Assignees_Text() {
        return langMap[ep.resxCulture].Assignees_Text || langMap.en.Assignees_Text;
    },
    /**
    * en: Total Project Budget:
    */
    get BudgetedCost_Text() {
        return langMap[ep.resxCulture].BudgetedCost_Text || langMap.en.BudgetedCost_Text;
    },
    /**
    * en: Contingency:
    */
    get BudgetPadding_Text() {
        return langMap[ep.resxCulture].BudgetPadding_Text || langMap.en.BudgetPadding_Text;
    },
    /**
    * en: Budget, total:
    */
    get BudgetTotal_Text() {
        return langMap[ep.resxCulture].BudgetTotal_Text || langMap.en.BudgetTotal_Text;
    },
    /**
    * en: Cancel
    */
    get Cancel() {
        return langMap[ep.resxCulture].Cancel || langMap.en.Cancel;
    },
    /**
    * en: Close
    */
    get Close() {
        return langMap[ep.resxCulture].Close || langMap.en.Close;
    },
    /**
    * en: Add 
    */
    get Combobox_Add() {
        return langMap[ep.resxCulture].Combobox_Add || langMap.en.Combobox_Add;
    },
    /**
    * en: Keep typing...
    */
    get Combobox_KeepTyping() {
        return langMap[ep.resxCulture].Combobox_KeepTyping || langMap.en.Combobox_KeepTyping;
    },
    /**
    * en: Select some options
    */
    get Combobox_MultipleSelectDefault() {
        return langMap[ep.resxCulture].Combobox_MultipleSelectDefault || langMap.en.Combobox_MultipleSelectDefault;
    },
    /**
    * en: No results
    */
    get Combobox_NoResults() {
        return langMap[ep.resxCulture].Combobox_NoResults || langMap.en.Combobox_NoResults;
    },
    /**
    * en: No results match 
    */
    get Combobox_NoResultsMatch() {
        return langMap[ep.resxCulture].Combobox_NoResultsMatch || langMap.en.Combobox_NoResultsMatch;
    },
    /**
    * en: You are about to change the date of an activity that has dependencies. This action will adjust the dependency lags to align with the new date you provided.
    */
    get confirmation_description_dependent_date() {
        return langMap[ep.resxCulture].confirmation_description_dependent_date || langMap.en.confirmation_description_dependent_date;
    },
    /**
    * en: This date is linked with a dependent activity
    */
    get confirmation_title_dependent_date() {
        return langMap[ep.resxCulture].confirmation_title_dependent_date || langMap.en.confirmation_title_dependent_date;
    },
    /**
    * en: Biling:
    */
    get Cost_Text() {
        return langMap[ep.resxCulture].Cost_Text || langMap.en.Cost_Text;
    },
    /**
    * en: Create and select
    */
    get CreateAndSelect() {
        return langMap[ep.resxCulture].CreateAndSelect || langMap.en.CreateAndSelect;
    },
    /**
    * en: Customer
    */
    get CustomerLabel() {
        return langMap[ep.resxCulture].CustomerLabel || langMap.en.CustomerLabel;
    },
    /**
    * en: 1#{0} day#{0} days
    */
    get day_template() {
        return langMap[ep.resxCulture].day_template || langMap.en.day_template;
    },
    /**
    * en: Duration
    */
    get Duration_Text() {
        return langMap[ep.resxCulture].Duration_Text || langMap.en.Duration_Text;
    },
    /**
    * en: Project members
    */
    get EditProjectMembers_Title() {
        return langMap[ep.resxCulture].EditProjectMembers_Title || langMap.en.EditProjectMembers_Title;
    },
    /**
    * en: Assignees
    */
    get EditTaskAssignees_Title() {
        return langMap[ep.resxCulture].EditTaskAssignees_Title || langMap.en.EditTaskAssignees_Title;
    },
    /**
    * en: End
    */
    get End_Text() {
        return langMap[ep.resxCulture].End_Text || langMap.en.End_Text;
    },
    /**
    * en: End date
    */
    get EndDate_Text() {
        return langMap[ep.resxCulture].EndDate_Text || langMap.en.EndDate_Text;
    },
    /**
    * en: Estimated hours:
    */
    get EstimatedHours_Text() {
        return langMap[ep.resxCulture].EstimatedHours_Text || langMap.en.EstimatedHours_Text;
    },
    /**
    * en: Estimated hours, total:
    */
    get EstimatedHours_Total_Text() {
        return langMap[ep.resxCulture].EstimatedHours_Total_Text || langMap.en.EstimatedHours_Total_Text;
    },
    /**
    * en: This field is for activities only <b style="white-space: nowrap;">({0} tasks, {1} issues, {2} requests)</b>
    */
    get field_for_all_activities() {
        return langMap[ep.resxCulture].field_for_all_activities || langMap.en.field_for_all_activities;
    },
    /**
    * en: This field is for <b style="white-space: nowrap;">{0} issues</b> only
    */
    get field_for_issues() {
        return langMap[ep.resxCulture].field_for_issues || langMap.en.field_for_issues;
    },
    /**
    * en: This field is for <b style="white-space: nowrap;">{0} projects</b> only
    */
    get field_for_projects() {
        return langMap[ep.resxCulture].field_for_projects || langMap.en.field_for_projects;
    },
    /**
    * en: This field is for <b style="white-space: nowrap;">{0} requests</b> only
    */
    get field_for_requests() {
        return langMap[ep.resxCulture].field_for_requests || langMap.en.field_for_requests;
    },
    /**
    * en: This field is for <b style="white-space: nowrap;">{0} tasks</b> only
    */
    get field_for_tasks() {
        return langMap[ep.resxCulture].field_for_tasks || langMap.en.field_for_tasks;
    },
    /**
    * en: h
    */
    get Hours_Short_Text() {
        return langMap[ep.resxCulture].Hours_Short_Text || langMap.en.Hours_Short_Text;
    },
    /**
    * en: Hours left:
    */
    get HoursLeftLabel() {
        return langMap[ep.resxCulture].HoursLeftLabel || langMap.en.HoursLeftLabel;
    },
    /**
    * en: Actual Cost:
    */
    get InternalCost_Text() {
        return langMap[ep.resxCulture].InternalCost_Text || langMap.en.InternalCost_Text;
    },
    /**
    * en: Non project members
    */
    get NonProjectMembers_Text() {
        return langMap[ep.resxCulture].NonProjectMembers_Text || langMap.en.NonProjectMembers_Text;
    },
    /**
    * en: Not members of the space
    */
    get Not_Space_Members() {
        return langMap[ep.resxCulture].Not_Space_Members || langMap.en.Not_Space_Members;
    },
    /**
    * en: Overloaded
    */
    get Overloaded_Text() {
        return langMap[ep.resxCulture].Overloaded_Text || langMap.en.Overloaded_Text;
    },
    /**
    * en: Time logs for the activity:
    */
    get OwnActualHours_Text() {
        return langMap[ep.resxCulture].OwnActualHours_Text || langMap.en.OwnActualHours_Text;
    },
    /**
    * en: Planned Expenses:
    */
    get PlannedExpenses_Text() {
        return langMap[ep.resxCulture].PlannedExpenses_Text || langMap.en.PlannedExpenses_Text;
    },
    /**
    * en: Portfolio
    */
    get PortfolioLabel() {
        return langMap[ep.resxCulture].PortfolioLabel || langMap.en.PortfolioLabel;
    },
    /**
    * en: Progress
    */
    get Progress() {
        return langMap[ep.resxCulture].Progress || langMap.en.Progress;
    },
    /**
    * en: Based on progress of subactivities
    */
    get ProgressCalculatedBySubActivities() {
        return langMap[ep.resxCulture].ProgressCalculatedBySubActivities || langMap.en.ProgressCalculatedBySubActivities;
    },
    /**
    * en: Time logs for activities:
    */
    get ProjectChildrenActualHours_Text() {
        return langMap[ep.resxCulture].ProjectChildrenActualHours_Text || langMap.en.ProjectChildrenActualHours_Text;
    },
    /**
    * en: Estimated hours for all activities:
    */
    get ProjectChildrenEstimatedHours_Text() {
        return langMap[ep.resxCulture].ProjectChildrenEstimatedHours_Text || langMap.en.ProjectChildrenEstimatedHours_Text;
    },
    /**
    * en: Project members
    */
    get ProjectMembers_Text() {
        return langMap[ep.resxCulture].ProjectMembers_Text || langMap.en.ProjectMembers_Text;
    },
    /**
    * en: Labor Budget for the project:
    */
    get ProjectOwnBudget_Text() {
        return langMap[ep.resxCulture].ProjectOwnBudget_Text || langMap.en.ProjectOwnBudget_Text;
    },
    /**
    * en: Estimated hours for the project:
    */
    get ProjectOwnEstimatedHours_Text() {
        return langMap[ep.resxCulture].ProjectOwnEstimatedHours_Text || langMap.en.ProjectOwnEstimatedHours_Text;
    },
    /**
    * en: Budget for all activities:
    */
    get ProjectSubactivitiesBudget_Text() {
        return langMap[ep.resxCulture].ProjectSubactivitiesBudget_Text || langMap.en.ProjectSubactivitiesBudget_Text;
    },
    /**
    * en: Space members
    */
    get Space_Members() {
        return langMap[ep.resxCulture].Space_Members || langMap.en.Space_Members;
    },
    /**
    * en: Start
    */
    get Start_Text() {
        return langMap[ep.resxCulture].Start_Text || langMap.en.Start_Text;
    },
    /**
    * en: Start date
    */
    get StartDate_Text() {
        return langMap[ep.resxCulture].StartDate_Text || langMap.en.StartDate_Text;
    },
    /**
    * en: Teams
    */
    get Teams_Text() {
        return langMap[ep.resxCulture].Teams_Text || langMap.en.Teams_Text;
    },
    /**
    * en: Editing time for an activity that occurred more than {0} in the past is not recommended. Are you sure you want to proceed?
    */
    get Timelogs_In_Past() {
        return langMap[ep.resxCulture].Timelogs_In_Past || langMap.en.Timelogs_In_Past;
    },
    /**
    * en: Editing time for an activity that occurred more than {0} in the past is not recommended
    */
    get Timelogs_In_Past_Short() {
        return langMap[ep.resxCulture].Timelogs_In_Past_Short || langMap.en.Timelogs_In_Past_Short;
    },
    /**
    * en: Adding time to a closed project is not recommended. Are you sure you want to proceed with adding time to the closed project?
    */
    get TimeLogs_Warning_Project_Closed() {
        return langMap[ep.resxCulture].TimeLogs_Warning_Project_Closed || langMap.en.TimeLogs_Warning_Project_Closed;
    },
    /**
    * en: Adding time to a closed project is not recommended
    */
    get TimeLogs_Warning_Project_Closed_Short() {
        return langMap[ep.resxCulture].TimeLogs_Warning_Project_Closed_Short || langMap.en.TimeLogs_Warning_Project_Closed_Short;
    },
    /**
    * en: Adding time to a closed activity is not recommended. Are you sure you want to proceed with adding time to this closed activity?
    */
    get TimeLogs_Warning_Task_Closed() {
        return langMap[ep.resxCulture].TimeLogs_Warning_Task_Closed || langMap.en.TimeLogs_Warning_Task_Closed;
    },
    /**
    * en: Adding time to a closed activity is not recommended
    */
    get TimeLogs_Warning_Task_Closed_Short() {
        return langMap[ep.resxCulture].TimeLogs_Warning_Task_Closed_Short || langMap.en.TimeLogs_Warning_Task_Closed_Short;
    },
    /**
    * en: {0} is linked with a dependent activity and cannot be changed
    */
    get Tooltip_Dependent_Template() {
        return langMap[ep.resxCulture].Tooltip_Dependent_Template || langMap.en.Tooltip_Dependent_Template;
    },
    /**
    * en: {0} is calculated based on subactivities and cannot be changed
    */
    get Tooltip_HasChildren_Template() {
        return langMap[ep.resxCulture].Tooltip_HasChildren_Template || langMap.en.Tooltip_HasChildren_Template;
    },
    /**
    * en: Cannot be edited since it is linked with a closed activity/project.
    */
    get Tooltip_ItemCompleted() {
        return langMap[ep.resxCulture].Tooltip_ItemCompleted || langMap.en.Tooltip_ItemCompleted;
    },
    /**
    * en: {0} cannot be changed. You have no permission to edit this field
    */
    get Tooltip_NoRightForUserRole_Template() {
        return langMap[ep.resxCulture].Tooltip_NoRightForUserRole_Template || langMap.en.Tooltip_NoRightForUserRole_Template;
    },
    /**
    * en: Please open the details to edit this field
    */
    get Tooltip_Open_Details() {
        return langMap[ep.resxCulture].Tooltip_Open_Details || langMap.en.Tooltip_Open_Details;
    },
    /**
    * en: changing the project actual completion date
    */
    get undo_action_Project_UpdateActualCompletionDate() {
        return langMap[ep.resxCulture].undo_action_Project_UpdateActualCompletionDate || langMap.en.undo_action_Project_UpdateActualCompletionDate;
    },
    /**
    * en: changing the project dates
    */
    get undo_action_Project_UpdateDates() {
        return langMap[ep.resxCulture].undo_action_Project_UpdateDates || langMap.en.undo_action_Project_UpdateDates;
    },
    /**
    * en: renaming the project
    */
    get undo_action_Project_UpdateName() {
        return langMap[ep.resxCulture].undo_action_Project_UpdateName || langMap.en.undo_action_Project_UpdateName;
    },
    /**
    * en: changing the project status
    */
    get undo_action_Project_UpdateStatus() {
        return langMap[ep.resxCulture].undo_action_Project_UpdateStatus || langMap.en.undo_action_Project_UpdateStatus;
    },
    /**
    * en: changing the activity actual completion date
    */
    get undo_action_Task_UpdateActualCompletionDate() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateActualCompletionDate || langMap.en.undo_action_Task_UpdateActualCompletionDate;
    },
    /**
    * en: changing the activity dates
    */
    get undo_action_Task_UpdateDates() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateDates || langMap.en.undo_action_Task_UpdateDates;
    },
    /**
    * en: editing the dependency
    */
    get undo_action_Task_UpdateDependencies() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateDependencies || langMap.en.undo_action_Task_UpdateDependencies;
    },
    /**
    * en: renaming the activity
    */
    get undo_action_Task_UpdateName() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateName || langMap.en.undo_action_Task_UpdateName;
    },
    /**
    * en: changing the activity status
    */
    get undo_action_Task_UpdateStatus() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateStatus || langMap.en.undo_action_Task_UpdateStatus;
    },
    /**
    * en: setting 'I'm done' for task assignment
    */
    get undo_action_Task_UpdateWorkIsDone() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateWorkIsDone || langMap.en.undo_action_Task_UpdateWorkIsDone;
    },
    /**
    * en: Untitled
    */
    get Untitled() {
        return langMap[ep.resxCulture].Untitled || langMap.en.Untitled;
    },
    /**
    * en: Actual completion date doesn't fall within the expected range.
    */
    get Validation_ActComplDateRange() {
        return langMap[ep.resxCulture].Validation_ActComplDateRange || langMap.en.Validation_ActComplDateRange;
    },
    /**
    * en: Date is a required field.
    */
    get Validation_DateMandatory() {
        return langMap[ep.resxCulture].Validation_DateMandatory || langMap.en.Validation_DateMandatory;
    },
    /**
    * en: Duration is a required field.
    */
    get Validation_DurationMandatory() {
        return langMap[ep.resxCulture].Validation_DurationMandatory || langMap.en.Validation_DurationMandatory;
    },
    /**
    * en: End date doesn't fall within the expected range.
    */
    get Validation_EndDateRange() {
        return langMap[ep.resxCulture].Validation_EndDateRange || langMap.en.Validation_EndDateRange;
    },
    /**
    * en: This is a required field.
    */
    get Validation_FieldMandatory() {
        return langMap[ep.resxCulture].Validation_FieldMandatory || langMap.en.Validation_FieldMandatory;
    },
    /**
    * en: From date doesn\'t fall within the expected range.
    */
    get Validation_FromDateRange() {
        return langMap[ep.resxCulture].Validation_FromDateRange || langMap.en.Validation_FromDateRange;
    },
    /**
    * en: Value must be integer.
    */
    get Validation_Interger() {
        return langMap[ep.resxCulture].Validation_Interger || langMap.en.Validation_Interger;
    },
    /**
    * en: Date must be in '{0}' format.
    */
    get Validation_InvalidDate() {
        return langMap[ep.resxCulture].Validation_InvalidDate || langMap.en.Validation_InvalidDate;
    },
    /**
    * en: Value must be between {0} and {1}.
    */
    get Validation_NumberRange() {
        return langMap[ep.resxCulture].Validation_NumberRange || langMap.en.Validation_NumberRange;
    },
    /**
    * en: Value doesn't fall within the expected range.
    */
    get Validation_Range() {
        return langMap[ep.resxCulture].Validation_Range || langMap.en.Validation_Range;
    },
    /**
    * en: Start date doesn't fall within the expected range.
    */
    get Validation_StartDateRange() {
        return langMap[ep.resxCulture].Validation_StartDateRange || langMap.en.Validation_StartDateRange;
    },
    /**
    * en: To date doesn\'t fall within the expected range.
    */
    get Validation_ToDateRange() {
        return langMap[ep.resxCulture].Validation_ToDateRange || langMap.en.Validation_ToDateRange;
    },
    /**
    * en: Value mustn't fall on a weekend or holiday.
    */
    get Validation_WeekendOrVacation() {
        return langMap[ep.resxCulture].Validation_WeekendOrVacation || langMap.en.Validation_WeekendOrVacation;
    },
    /**
    * en: Removed members will be unassigned from all activities in this project.
    */
    get Warning_UnassigneFromAllTasksInProject() {
        return langMap[ep.resxCulture].Warning_UnassigneFromAllTasksInProject || langMap.en.Warning_UnassigneFromAllTasksInProject;
    },
    /**
    * en: Removed member will be unassigned from all activities in this project.
    */
    get Warning_UnassignFromAllTasksInProject_Single() {
        return langMap[ep.resxCulture].Warning_UnassignFromAllTasksInProject_Single || langMap.en.Warning_UnassignFromAllTasksInProject_Single;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.inlineEdit = inlineEditResx;
